import * as React from 'react'
import { SVGProps } from 'react'
const SvgCompass: React.FC<React.SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="compass_svg__lucide compass_svg__lucide-drafting-compass-icon compass_svg__lucide-drafting-compass"
    {...props}>
    <path d="m12.99 6.74 1.93 3.44M19.136 12a10 10 0 0 1-14.271 0M21 21l-2.16-3.84M3 21l8.02-14.26" />
    <circle cx={12} cy={5} r={2} />
  </svg>
)
export default SvgCompass
